const FilePicker   = require('./FilePicker');
const to_array     = require('./to_array')
const template     = require('lodash/template')
const dialog       = require('../templates/conciliacao-despesas.html');
const GlobalAlerts = require('./GlobalAlerts');
const moment       = require('moment');
const Lang         = require('lang');

/**
 * Função para alteração da data de uma conciliação
 */
function AlterarConciliacao() {
  nifty.body.overlay({
    fixed: true
  })
  const conciliationsButtons = to_array(document.querySelectorAll('.edit-conciliation'))
  conciliationsButtons.forEach(addEventListener)
}

/**
 * Adicionar evento as linhas da tabela de resultado
 *
 * @param {element} reportRow linha da tabela
 */
function addEventListener(reportRow) {
  reportRow.addEventListener('click', clickHandler)
}

/**
 * Evento de clique da linha da tabela
 *
 * @param  {evento} event evento de click
 */
function clickHandler(event) {
  event.preventDefault()
  event.stopPropagation()
  const elDataset = event.currentTarget.dataset;

  getReport(elDataset.conciliationId)
    .done(function (data) {
      showModal(data, elDataset);
    })
    .fail(function (error) {
      GlobalAlerts.create({
        type: 'danger',
        title: Lang.get('js/src/functions/AlterarConciliacao.ops'),
        message: Lang.get('js/src/functions/AlterarConciliacao.not_get_data_conciliation'),
      });
    });
}

/**
 * Esta função irá estanciar o modal do nifty, para
 * receber o valor da nova data e desparar a requisição
 *
 * @param  {Object} conciliationData Objeto contendo os dados da conciliação
 *
 * @return {element}        Modal do nifty
 */
function showModal(conciliationData, elDataSet) {
  conciliationData = conciliationData[0];

  const modal = bootbox.dialog({
    title: Lang.get('js/src/functions/AlterarConciliacao.conciliation') + ': ' + formatDate(conciliationData.data),
    message: dialog,
    buttons: {
      cancel: {
        label: Lang.get('js/src/functions/AlterarConciliacao.cancel'),
        className: 'btn-danger'
      },
      confirm: {
        label: Lang.get('js/src/functions/AlterarConciliacao.change'),
        className: 'btn-success',
        callback: function () {
          nifty.body.overlay('show');
          const formModal = document.querySelector('#form-conciliation-modal');
          const object = new FormData(formModal);

          updateReport(conciliationData.id, object)
            .done(function (data) {
              GlobalAlerts.create({
                title: Lang.get('js/src/functions/AlterarConciliacao.success'),
                message: Lang.get('js/src/functions/AlterarConciliacao.conciliation_chaged_succes'),
              });
              $('#default-filter-data').trigger('click');
            })
            .fail(function (error) {
              GlobalAlerts.create({
                type: 'danger',
                title: Lang.get('js/src/functions/AlterarConciliacao.ops'),
                message: error.responseJSON.message,
              });
            })
            .always(function () {
              nifty.body.overlay('hide');
            })
        }
      }
    }
  })

  /**
   * Evento de carregamento do modal,
   * adicionando o comportamento do datepicker à input de data
   */
  modal.on('shown.bs.modal', function () {
    FilePicker.init();
    loadContentFileInFilePicker(elDataSet);
    translateLabelsForm($(this), conciliationData);

    const inputData = $(this).find('#dataConciliacao');
    const inputDescricao = $(this).find('#descricao').get(0);
    const inputIof = $(this).find('#iof').get(0);
    const inputVariacaoCambial = $(this).find('#variacaoCambial').get(0);
    const inputOutros = $(this).find('#outros').get(0);

    inputDescricao.value = conciliationData.descricao;
    inputIof.value = conciliationData.iof;
    inputVariacaoCambial.value = conciliationData.variacaoCambial;
    inputOutros.value = conciliationData.outros;

    inputData.datepicker();
    inputData.datepicker('setDate', formatDate(conciliationData.data));
  })

  return modal;
}

/**
 * Completar a label das taxas com a iso da moeda padrao
 * da empresa
 *
 * @param  element buttonConciliation [description]
 */
function translateLabelsForm(form, conciliationData) {
  const currencyDefault = conciliationData.moeda.codigo_iso;

  const descricao = form.find('#labelDescricao').get(0);
  const dataConciliacao = form.find('#labelDataConciliacao').get(0);
  const iof = form.find('#labelIof').get(0);
  const variacaoCambial = form.find('#labelVariacaoCambial').get(0);

  // File Picker
  const filePickerTitle = form.find('#file-picker-title').get(0);
  const filePickerImage = form.find('#file-picker-image').get(0);
  const filePickerPdf = form.find('#file-picker-pdf').get(0);
  const filePickerRemove = form.find('#file-picker-remove').get(0);
  const filePickerLinkPdf = form.find('#file-picker-link-pdf').get(0);

  descricao.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.description');
  dataConciliacao.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.conciliation_date');
  iof.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.rate_iof', { isoMoedaPadrao: currencyDefault });
  variacaoCambial.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.rate_exchange_variation', { isoMoedaPadrao: currencyDefault });

  // File Picker
  filePickerTitle.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.file_picker_title');
  filePickerImage.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.file_picker_image');
  filePickerPdf.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.file_picker_pdf');
  filePickerRemove.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.file_picker_remove');
  filePickerLinkPdf.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.file_picker_view_pdf');
}

/**
 * Carregar aquivo no file Picker
 *
 * @param  {Object} elDataSet
 */
function loadContentFileInFilePicker(elDataSet) {
  const formModal = document.querySelector('#form-conciliation-modal');
  const filePiker = $(formModal).find('#file-picker').get(0);

  if (elDataSet.conciliationAttachmentUrl != 'null') {
    filePiker.classList.add('has-file');

    if (elDataSet.conciliationAttachmentType == 'IMG') {
      filePickerContentImage(formModal, elDataSet);
      return;
    }
    filePickerContentPdf(formModal, elDataSet);
  }
}

/**
 * Configurar o file picker para exibir a imagem
 * que já está vinculada com a conciliação, por
 * meio os controles que ele já possui
 *
 * @param  {element} formModal
 * @param  {object} elDataSet
 */
function filePickerContentImage(formModal, elDataSet) {
  const filePickerButtonsControl = $(formModal).find('.file-picker__add').get();

  const filePickerZoomImage = $(formModal).find('.file-picker__zoom').get(0);
  const filePickerImage = $(formModal).find('.file-picker__image').get(0);
  const filePickerFileName = $(formModal).find('.file-picker__file-name').get(0);

  filePickerZoomImage.setAttribute('href', elDataSet.conciliationAttachmentUrl);
  filePickerZoomImage.classList.remove('hidden');

  filePickerImage.setAttribute('src', elDataSet.conciliationAttachmentUrl);
  filePickerImage.classList.remove('hidden');

  disableButtonsAddFile(filePickerButtonsControl);
}

/**
 * Configurar o file picker para exibir o arquivo PDF
 * que já está vinculado com a conciliação, por
 * meio os controles que ele já possui
 *
 * @param  {element} formModal
 * @param  {object} elDataSet
 */
function filePickerContentPdf(formModal, elDataSet) {
  const filePickerButtonsControl = $(formModal).find('.file-picker__add').get();
  const filePickerLinkPdf = $(formModal).find('#file-picker-link-pdf').get(0);

  filePickerLinkPdf.setAttribute('href', elDataSet.conciliationAttachmentUrl);
  filePickerLinkPdf.classList.remove('hidden');

  disableButtonsAddFile(filePickerButtonsControl);
}

/**
 * adicionando a classe hidden em todos os botoes de interação
 * com o arquivo do file picker, exceto no botão de remover
 * arquivo
 *
 * @param  {Array} filePickerButtonsControl
 */
function disableButtonsAddFile(filePickerButtonsControl) {
  filePickerButtonsControl.forEach((currentButton) => {
    currentButton.classList.add('hidden');

    if (currentButton.classList.contains('file-picker__add--remove')) {
      currentButton.classList.remove('hidden');
    }
  })
}

/**
 * Requisição para alteração de data
 *
 * @param  {int} id
 * @param  {date} dataConciliacao
 * @param  {string} obs
 *
 * @return $.ajax;
 */
function updateReport(id, data) {
  return $.ajax({
    method: 'POST',
    url: route('app.admin.conciliacoes.extrato.alterar', {
      idConciliacao: id
    }),
    data: data,
    contentType: false,
    processData: false
  });
}

/**
 * requisição para obter os dados da concoiliação
 *
 * @param  {int} id
 *
 * @return {$.ajax}
 */
function getReport(id) {
  return $.ajax({
    method: 'GET',
    dataType: 'json',
    url: route('app.admin.conciliacoes.edit', {
      id: id
    })
  });
}

/**
 * Formatar a data para exibição
 *
 * @param  {data} date
 *
 * @return {string}      data formatada
 */
function formatDate(date) {
  return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
}

/**
 * Exportação da função
 *
 * @type {Object}
 */
module.exports = {
  init: AlterarConciliacao,
  url: route('app.admin.conciliacoes.extrato')
}

